// extracted by mini-css-extract-plugin
export default {"wrap":"ky-z","fullWidth":"ly-z","items":"my-z","featureCss":"ny-z","disabled":"oy-z","imgCss":"py-z"};